module.exports = __webpack_public_path__ + "static/media/fastpay-logo.2f2c0991.svg";